import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Nav({ crumbs }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toneClass = (i) => (i === 0 ? "crumb--product" : i === crumbs.length - 1 && crumbs.length > 1 ? "crumb--leaf" : "crumb--role");

  return (
    <nav className="nav on-dark" data-testid="top-nav">
      <button className="nav__brand" onClick={() => navigate("/")} data-testid="nav-home">
        <span className="nav__logo">EQUIPR</span>
        <span className="nav__academy">Academy</span>
      </button>
      <div className="nav__crumbs">
        {crumbs.map((c, i) => (
          <span key={i} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span className="nav__slash">/</span>
            {c.to && i !== crumbs.length - 1 ? (
              <button className={`crumb ${toneClass(i)}`} onClick={() => navigate(c.to)} data-testid={`crumb-${i}`}>
                {c.label}
              </button>
            ) : (
              <span className={`crumb ${toneClass(i)}`}>{c.label}</span>
            )}
          </span>
        ))}
      </div>
      <div className="nav__right">
        <button className="nav__link" onClick={() => navigate("/products")} data-testid="nav-products">Products</button>
        <button className="nav__link" onClick={() => navigate("/certifications")} data-testid="nav-certifications">My certifications</button>
        <a className="nav__link" href="https://help.equipr.software" target="_blank" rel="noreferrer" data-testid="nav-help">Help Center</a>
        <div className="nav__user">
          <button className="nav__userbtn" onClick={() => setMenuOpen((o) => !o)} data-testid="nav-user">
            <span className="nav__avatar">{user?.initials}</span>
            {user?.name}
          </button>
          {menuOpen && (
            <div className="menu" data-testid="user-menu">
              <button className="menu__item" onClick={() => { setMenuOpen(false); navigate("/certifications"); }} data-testid="menu-certifications">My certifications</button>
              <button className="menu__item" onClick={() => { setMenuOpen(false); logout(); }} data-testid="nav-signout">Sign out</button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="footer on-dark" data-testid="footer">
      <span className="footer__brand">ACADEMY.EQUIPR.SOFTWARE &nbsp;·&nbsp; V1.0</span>
      <span className="footer__note">Products are separate courses under one shell. Nothing is shared between them.</span>
    </footer>
  );
}

export default function Shell() {
  const [crumbs, setCrumbs] = useState([]);
  return (
    <div className="app-root">
      <Nav crumbs={crumbs} />
      <div className="app-main">
        <Outlet context={{ setCrumbs }} />
      </div>
      <Footer />
    </div>
  );
}
